import { generatePath, NavLink } from "react-router-dom";

import Button from "~/components/buttons/Button";
import Headline from "~/components/Headline";
import OverflowPercentageChart from "~/components/OverflowPercentageChart";
import { QUOTA_DETAILS_PATH } from "~/constants/appRoutes.ts";
import type { QuotaWithRelations } from "~/modules/client/api/quota/quotaTypes.ts";
import QuotaStatusBadge from "~/modules/client/components/quota/QuotaDetailsView/components/QuotaStatusBadge.tsx";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";

type Props = {
	quota: QuotaWithRelations
};

const QuotaListItem = ({ quota }: Props) => {
	const percentageTracked = (quota.budgetCentsTracked / quota.budgetCentsPlanned) * 100;
	const percentageTrackedFormatted = percentageTracked === Infinity ? "n/a" : percentageTracked.toFixed(0) + "%";

	return <NavLink to={generatePath(QUOTA_DETAILS_PATH, { clientId: quota.clientId, quotaId: quota.id })}
					className={`group flex items-center gap-x-2 rounded-lg bg-white px-4 py-3 shadow
					transition-transform duration-200 hover:shadow-md`}>
		<OverflowPercentageChart percentage={percentageTracked === Infinity ? 0 : percentageTracked}
								 size={60}
								 thickness={0.5}>
			<div className="text-center text-xs font-bold">
				{percentageTrackedFormatted}
			</div>
		</OverflowPercentageChart>
		<div className="ml-2 flex flex-col gap-y-1">
			<div className="flex items-center gap-x-2">
				<Headline type="h4">{quota.title}</Headline>

			</div>
			<div className="flex items-center gap-x-2 text-sm text-gray-600">
				<div className=" text-gray-600">
					Budget: <span className="font-bold">{formatCentsToCurrency(quota.budgetCentsPlanned, 2)}</span>
				</div>
				<span>|</span>
				<div className="text-sm text-gray-600">
					Phasen: <span className="font-bold">{quota.projectPhases.length}</span>
				</div>
				<span>|</span>
				<div className="text-sm text-gray-600">
					Status: 				<QuotaStatusBadge isBookable={quota.isBookable} />

				</div>
			</div>
		</div>
		<div className="ml-auto">
			<Button theme="primary" size="sm">Alle Details</Button>
		</div>
	</NavLink>;
};

export default QuotaListItem;